import { useEffect, useState } from "react";
import { BrandLogo } from "./BrandLogo";
import styles from "./SplashScreen.module.css";

export const SplashScreen = () => {
  const [isVisible, setIsVisible] = useState(() => {
    if (typeof window === "undefined") return false;
    const hasSeenSplash = sessionStorage.getItem("hasSeenSplash");
    if (!hasSeenSplash) {
      sessionStorage.setItem("hasSeenSplash", "true");
      return true;
    }
    return false;
  });
  
  const [isFading, setIsFading] = useState(false);

  useEffect(() => {
    if (isVisible) {
      // Start fade out after 1 second
      const fadeTimer = setTimeout(() => {
        setIsFading(true);
      }, 1000);

      // Unmount after fade out completes (500ms fade duration)
      const unmountTimer = setTimeout(() => {
        setIsVisible(false);
      }, 1500);

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(unmountTimer);
      };
    }
  }, [isVisible]);

  if (!isVisible) return null;

  return (
    <div className={`${styles.splashScreen} ${isFading ? styles.fadeOut : ""}`}>
      <div className={styles.content}>
        <BrandLogo
          size={100}
          imageClassName={styles.icon}
        />
        <h1 className={styles.title}>BhadaPMS</h1>
        <p className={styles.tagline}>Property Management System</p>
      </div>
    </div>
  );
};